var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        { name: "show", rawName: "v-show", value: _vm.show, expression: "show" }
      ],
      staticClass: "lite_popup lite_tree"
    },
    [
      _c(
        "div",
        { staticClass: "lite_popup_box" },
        [
          _c("div", { staticClass: "lite_popup_title" }, [
            _c("span", [
              _vm._v(
                _vm._s(_vm.$t("language.popup.cloudTransferPopup.pleaSelect"))
              )
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "icon white-close dialog-close",
              on: {
                click: function($event) {
                  _vm.show = false
                }
              }
            })
          ]),
          _vm._v(" "),
          _vm.showBlank
            ? _c("div", { staticClass: "real-nodrives" }, [
                _c("div", {
                  staticClass: "nondrive-realtime",
                  on: {
                    click: function($event) {
                      return _vm.toAddCloudPage()
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "nondrive-realtimedes",
                    on: {
                      click: function($event) {
                        return _vm.toAddCloudPage()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$t(
                            "language.popup.cloudTransferPopup.addValidCloud"
                          )
                        ) +
                        "\n            "
                    )
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.showWebsite && _vm.onlyWebsite && _vm.websiteTips
            ? _c("div", { staticClass: "add_website_blank" })
            : _vm._e(),
          _vm._v(" "),
          !_vm.showWebsite && _vm.onlyWebsite
            ? _c(
                "div",
                {
                  staticClass: "add_website",
                  class: _vm.websiteTips ? "showTips" : "",
                  on: {
                    click: function($event) {
                      return _vm.readyAddWebsite()
                    }
                  }
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("language.common.addWebsite")))
                  ]),
                  _vm._v(" "),
                  _vm.websiteTips
                    ? _c(
                        "div",
                        {
                          staticClass: "lite_my_tips",
                          attrs: { "data-language": _vm.$i18n.locale },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.donot()
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "lite_my_tips_triangle" }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass:
                              "lite_my_tips_close icon-util bubble-close",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.hideAddWebsiteTips()
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "lite_my_tips_text" }, [
                            _vm._v(_vm._s(_vm.$t("language.common.websiteTip")))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "lite_my_tips_btn" }, [
                            _c(
                              "button",
                              {
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.hideAddWebsiteTips()
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("language.common.ok")))]
                            )
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.show
            ? _c(
                "div",
                { staticClass: "lite_popup_content myscroll" },
                [
                  _c("el-tree", {
                    ref: "liteTree",
                    staticClass: "lite-file-tree",
                    attrs: {
                      "node-key": "id",
                      props: _vm.props,
                      load: _vm.loadNode,
                      "expand-on-click-node": false,
                      lazy: "",
                      "show-checkbox": _vm.showCheckbox,
                      "empty-text": ""
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var node = ref.node
                            var data = ref.data
                            return _c(
                              "span",
                              { staticClass: "custom-tree-node" },
                              [
                                node.level == 1
                                  ? _c(
                                      "span",
                                      {
                                        class:
                                          "drive-icon drive-icon-" + data.icon
                                      },
                                      [_vm._v(_vm._s(data.name))]
                                    )
                                  : _c("span", [
                                      _c("img", {
                                        staticClass: "node-icon",
                                        attrs: {
                                          src:
                                            "/static/file/" + data.icon + ".svg"
                                        },
                                        on: {
                                          error: function(e) {
                                            return (e.target.src =
                                              "/static/file/file.svg")
                                          }
                                        }
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "node-name-label" },
                                        [_vm._v(_vm._s(data.name))]
                                      )
                                    ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "more-options" }, [
                                  node.next
                                    ? _c("div", {
                                        staticClass:
                                          "lite_select_more lite_select_next",
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.loadNext(node)
                                          }
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showMkdir(node)
                                    ? _c("div", {
                                        staticClass:
                                          "lite_select_more lite_select_mkdir",
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.showInputPopup(node)
                                          }
                                        }
                                      })
                                    : _vm._e()
                                ])
                              ]
                            )
                          }
                        }
                      ],
                      null,
                      false,
                      3598582282
                    )
                  }),
                  _vm._v(" "),
                  _c("div", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isLoadDrives,
                        expression: "isLoadDrives"
                      }
                    ],
                    staticClass: "lite-select-loading"
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "lite_popup_footer" }, [
            _c("button", { on: { click: _vm.selectDone } }, [
              _vm._v(_vm._s(_vm.$t("language.common.ok")))
            ])
          ]),
          _vm._v(" "),
          _c("liteInput", {
            ref: "inputPopup",
            attrs: { data: _vm.input_popup_data },
            on: { ok: _vm.inputPopupOK }
          }),
          _vm._v(" "),
          _c("liteAddDrive", {
            attrs: { auth: _vm.auth },
            on: {
              submit: function($event) {
                return _vm.addWebsite()
              }
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ecdfdd3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ecdfdd3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workspace/lite_select.vue
// module id = null
// module chunks = 